import React from 'react';
import { useTranslation } from 'react-i18next';
import EditorAlignLeft from '@wix/da-ds/pkg/Icons/24x24/EditorAlignLeft';
import EditorAlignRight from '@wix/da-ds/pkg/Icons/24x24/EditorAlignRight';
import EditorAlignCenter from '@wix/da-ds/pkg/Icons/24x24/EditorAlignCenter';
import EditorAlignJustify from '@wix/da-ds/pkg/Icons/24x24/EditorAlignJustify';
import { isExtensionInstalled } from '../../utils/tiptap';
import EditorIconButtonWithContextMenu from '../_partials/EditorIconButtonWithContextMenu';
const Alignment = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'textAlignment')) {
        return null;
    }
    const isThatShitBrowserSafari = 'WebkitAppearance' in document.documentElement.style && !/Chrome/.test(navigator.userAgent);
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        featureId: "format:align",
        tooltipText: t('button.alignment.tooltip'),
        "aria-label": t('button.alignment.tooltip'),
        icon: EditorAlignLeft,
        disabled: !editor.can().chain().focus().setTextAlign('center').run(),
        items: [
            {
                featureId: 'format:alignLeft',
                label: t('button.alignment.left'),
                IconComponent: EditorAlignLeft,
                isActive: editor.isActive({
                    textAlign: 'left'
                }),
                onClick: ()=>{
                    editor.chain().focus().setTextAlign('left').run();
                }
            },
            {
                featureId: 'format:alignCenter',
                label: t('button.alignment.center'),
                IconComponent: EditorAlignCenter,
                isActive: editor.isActive({
                    textAlign: 'center'
                }),
                onClick: ()=>{
                    editor.chain().focus().setTextAlign('center').run();
                }
            },
            {
                featureId: 'format:alignRight',
                label: t('button.alignment.right'),
                IconComponent: EditorAlignRight,
                isActive: editor.isActive({
                    textAlign: 'right'
                }),
                onClick: ()=>{
                    editor.chain().focus().setTextAlign('right').run();
                }
            },
            !isThatShitBrowserSafari && {
                featureId: 'format:alignJustify',
                label: t('button.alignment.justify'),
                IconComponent: EditorAlignJustify,
                isActive: editor.isActive({
                    textAlign: 'justify'
                }),
                onClick: ()=>{
                    editor.chain().focus().setTextAlign('justify').run();
                }
            }
        ]
    });
};
Alignment.displayName = 'Alignment';
export default Alignment;

//# sourceMappingURL=Alignment.js.map